import { SimpleEntityGridActionCellButton } from "src/app/components/grid/CellRenderer/SimpleEntityGridActionCell/SimpleEntityGridActionCell";

export default function useLibraryGridActions() {
    const actions: SimpleEntityGridActionCellButton[] = ["viewText", "disable"];

    return actions;
}
